import { CheckoutResult } from 'features/checkout/payment/checkoutResult.types';

const convertPaymentResult = (_: CheckoutResult): google.payments.api.PaymentAuthorizationResult => {
  return { transactionState: 'SUCCESS' };
};

export { convertPaymentResult };
